export interface ChainOfResponsibilityHandler<HandleArgs> {
  setNext: (h: ChainOfResponsibilityHandler<HandleArgs>) => void;
  handle: (args: HandleArgs) => Promise<void> | void;
}

export type ChainOfResponsibilityHandlerArgs<HandleArgs> = {
  customHandle: (args: HandleArgs, resume: () => Promise<void>) => Promise<boolean> | boolean;
};

export const chainOfResponsibilityHandler = <HandleArgs>({
  customHandle,
}: ChainOfResponsibilityHandlerArgs<HandleArgs>): ChainOfResponsibilityHandler<HandleArgs> => {
  let next: ChainOfResponsibilityHandler<HandleArgs> | undefined;
  const setNext = (h: ChainOfResponsibilityHandler<HandleArgs>) => {
    next = h;
  };

  const handle = async (args: HandleArgs) => {
    const canHandleNext = await customHandle(args, () => resume(args));
    if (next && canHandleNext) next.handle(args);
  };

  const resume = async (args: HandleArgs) => {
    if (next) await next.handle(args);
  };

  return { setNext, handle };
};
